<template>
 <div class="row">
     <div class="col-md-4 mt-4">
         <div class="card border-0">
             <div class="card-header">
                 <span>My Prescriptions</span>
             </div>
             <div class="card-body gray-bg">
                 <div class="row justify-content-center ">
                     <div class="col-md-12">
                         <ul class="list-group mb-3" v-if="rxs.length>0">
                             <li :class="(r.conditions.length>0?'border-bottom-0 ':'')+'list-group-item border-top-0 border-right-0 border-left-0 ml-0 mr-0'" v-for="r in rxs">
                                 <div class="row">
                                     <div class="col-md-9 sb-list-fitem-regular">
                                         {{ r.pre_sr ? r.pre_srname : (r.prescription_data ? r.prescription_data.prd_name : '') }}
                                     ({{ r.pre_dosage }} {{ r.dosage ? r.dosage.dos_type : '' }})                                     </div>
                                     <div class="col-md-3 text-right sb-list-sitem">
                                         <a href="#" class="text-danger" title="remove prescription" @click.prevent="deleteRxById(r)">
                                             Remove
                                         </a>
                                     </div>
                                     <div v-if="true" class="col-md-2 text-right sb-list-sitem">
                                         <a href="#" title="edit prescription" class="" @click.prevent="show(r)">
                                             Edit
                                         </a>
                                     </div>
                                 </div>
                                 <ul class="list-group">
                                     <li class="list-group-item border-top-0 border-left-0 border-right-0 pt-1 pb-1 sb-list-thitem-regular  pl-3" v-for="c in r.conditions">
                                         <div class="shifted"> {{ c.cnd_sr ? c.cnd_srname : (c.condition_data ? c.condition_data.cdd_name : '') }}</div>
                                     </li>
                                 </ul>
                             </li>
                         </ul>
                     </div>
                     <div v-if="isMobile" class="col-md-12 mb-2 text-center mt-3">
                         <a href="/my-health/prescriptions/add" class="btn btn-primary ">Add New Prescription</a>
                     </div>
                 </div>
             </div>
         </div>
     </div>
     <div class="col-md-8 mt-4">
         <div class="card border-0">
             <div class="card-header">
                 <span><span v-if="update">Edit </span><span v-else>New </span>Prescription</span>
             </div>
             <div class="card-body gray-bg">
                 <div class="justify-content-center" v-if="update && rx.id==''">
                     <div class="col-md-12 text-center pb-3">
                        <h5 class="mt-5 mb-5">SELECT PRESCRIPTION TO EDIT</h5>
                     </div>
                 </div>
                 <div v-else class="justify-content-center">
                     <div class="col-md-12">
                         <div id="rx-form">
                             <div class="form-group">
                                 <label class="mb-0">What is your new prescription?</label>
                                 <small class="form-text text-muted mb-2">Entering the first few letters of your new prescription will display a suggestion.</small>
                             <multiselect
                                     v-model="rx.pre_prd"
                                     track-by="prd_id"
                                     label="prd_name"
                                     placeholder="Type to search prescription"
                                     :searchable="true"
                                     :allow-empty="false"
                                     :options="searchrxs"
                                     @search-change="asyncFindRx"
                                     ref="multiselect"
                                     :taggable="true"
                                     @tag="addSrPre"
                                     tag-placeholder="Add new prescription"
                             >
                                 <template slot="noOptions">Please type to search</template>
                             </multiselect>

                             </div>
                             <div class="form-group">
                                 <input type="hidden" name="pre_prdid">
                             </div>
                             <div class="row">
                                 <div class="col-7 col-md-9 form-group">
                                    <label for="pre_dosage" id="pre_dosage_description" class="mb-0">Dosage</label>
                                         <input type="number"
                                            placeholder="Dosage"
                                            title="Dosage"
                                            v-model="rx.pre_dosage"
                                            id="pre_dosage"
                                            name="pre_dosage"
                                            class="required form-control"
                                            aria-label="Dosage"
                                            aria-describedby="pre_dosage_description"
                                            aria-required="true"
                                            />
                                 </div>
                                 <div class="col-5 col-md-3 form-group">
                                    <label for="pre_dosid" id="pre_dosid_description" class="mb-0">Units</label>
                                         <select name="pre_dosid"
                                            v-model="rx.pre_dosid"
                                            class="form-control required"
                                            title="Units"
                                            aria-label="Units"
                                            aria-describedby="pre_dosid_description"
                                            aria-required="true"
                                            >
                                             <option v-for="dosage in dosages" :value="dosage.dos_id">
                                                 {{ dosage.dos_type }}
                                             </option>
                                         </select>

                                 </div>
                             </div>

                             <div class="form-group">
                                 <label class="mb-0">What condition is this prescription for?</label>
                                 <small class="form-text text-muted mb-2">Entering the first few letters of your condition will display a suggestion from your list.</small>
                             <multiselect
                                     v-model="rx.conditions"
                                     track-by="cnd_id"
                                     :custom-label="customLabel"
                                     placeholder="Type to search condition"
                                     :searchable="true"
                                     :multiple="true"
                                     :allow-empty="true"
                                     :options="searchcons"
                                     @search-change="asyncFindConditionAdd"
                                     :taggable="true"
                                     @tag="addSrCon"
                                     tag-placeholder="Add new condition"
                             >
                                 <template slot="noOptions">Please type to search</template>
                             </multiselect>

                             </div>
                             <div class="row">
                                 <div class="col-md-4">
    <!--                                 <a href="#" type="button" class="btn btn-primary btn-sb">I have another prescription</a>-->
                                 </div>
                                 <div class="col-md-8 text-right pt-2 mb-2">
                                     <a href="#" @click.prevent="rxForm=!rxForm" v-if="!rxForm" class="primary-link">I don't see my condition in the list</a>
                                 </div>
                             </div>
                             <div id="con-form" v-if="rxForm" class="row">
                                 <div class="col-md-6 form-group ">
                                     <label name="new_condition">New condition</label>
<!--                                     <small class="form-text text-muted mb-2">&nbsp;</small>-->
                                 <multiselect
                                     v-model="con.cnd_cdd"
                                         track-by="cdd_id"
                                         label="cdd_name"
                                         placeholder="Type to search condition"
                                         :searchable="true"
                                         :allow-empty="false"
                                         :options="searchconditions"
                                         :limit="3"
                                         @search-change="asyncFindCondition"
                                         :taggable="true"
                                         @tag="addSrCon"
                                         tag-placeholder="Add new condition"
                                 >
                                     <template slot="noOptions">Please type to search</template>
                                 </multiselect>

                                 </div>
                                     <div class="col-7 col-md-4 form-group">
                                         <small class="form-text text-muted mb-2">&nbsp;</small>
                                         <input type="text" placeholder="Note" v-model="con.cnd_name" id="cnd_name" name="cnd_name" class="required form-control"/>
                                     </div>
                                     <div v-if="isMobile" class="col-2"></div>
                                     <div class="col-3 col-md-2 form-group text-center pt-3">
                                         <a href="#" @click.prevent="conFormCancel" class="primary-link">Remove</a>
                                         <button type="button" class="btn btn-primary mt-3" @click.prevent="saveCon">Add</button>
                                     </div>

                                 </div>
                         </div>
                         <div class="text-right mb-3 mt-30-important">
                             <button v-if="!update" type="button" class="btn btn-primary" @click.prevent="saveRx">Add to My Prescriptions</button>
                             <button v-if="update" type="button" class="btn btn-primary" @click.prevent="updateRx">Update My Prescription</button>
                             <a href="/my-health" type="button" class="btn btn-outline-success ml-4" title="Redirect to Health Page">Cancel</a>
                         </div>

                     </div>
                 </div>
             </div>
         </div>
     </div>
 </div>
</template>

<style>
    .mt-30-important {
        margin-top: 30px !important;
    }
    .multiselect__placeholder {
        color:#6C757D;
        font-size: 1.0625rem;
        font-weight: 400;
        line-height: 1.4706;
    }
</style>

<script>
export default {
    props: ['conditions', 'methodtype', 'prescriptions', 'dosages'],
    mounted() {
        this.listRx();
        this.getCon();
        this.update = this.methodtype !== 'add';
    },
    created: function () {
        bus.$on('updateConditions', this.listCon)
        bus.$on('updateOldCondition', this.updateOldCondition)
        bus.$on('addCon', this.addConFromRx)
    },
    data() {
        return {
            conroute: '/api/conditions',
            route: '/api/prescriptions',
            update: false,
            fromRx: false,
            rxForm: false,
            condition: '',
            searchcons: [],
            searchrxs: [],
            con: {
                id: null,
                cnd_cdd: null,
                cnd_cddid: null,
                cnd_name: '',
                cnd_srname: '',
                prescriptions: [],
            },
            cons: [],
            rx_name: '',
            searchconditions: [],
            searchprescriptions: [],
            addsearchprescriptions: [],
            rx: {
                id: null,
                pre_prd: null,
                pre_prdid: {prd_id: null},
                pre_name: '',
                pre_srname: '',
                pre_dosage: '',
                pre_dosid: '',
                conditions: []
            },
            rxs: []
        }
    },
    computed: {
        isMobile() {
            return screen.width < 577;
        }
    },
    methods: {
        listRx() {
            this.$http.get(this.route)
                .then(function (response) {
                    this.rxs = response.data;
                    bus.$emit('listRX', this.rxs);
                }, (response) => {
                    this._handleErrors(response.data, '#rx-form')
                })
        },
        conFormCancel() {
            this.rxForm = false;
            this.con = {
                id: null,
                cnd_cdd: null,
                cnd_cddid: null,
                cnd_name: '',
                cnd_srname: '',
                prescriptions: [],
            }
        },
        saveRx() {
            if (this.rxForm) {
                let error_message = 'Please finish adding the new condition by tapping on &quot;add&quot; or click remove.';
                let data = {
                    'message': error_message,
                    'errors': {
                        'cnd_name': [error_message]
                    }
                };
                this._handleErrors(data, '#rx-form');
                return false;
            }

            //null safe injection
            if (this.rx.pre_prd == null) {
                this.rx.pre_prd = {prd_id: null};
            }

            this.$http.post(this.route, {
                pre_prdid: this.rx.pre_prd.prd_id,
                pre_name: this.rx.pre_name,
                pre_srname: this.rx.pre_srname,
                pre_dosage: this.rx.pre_dosage,
                pre_dosid: this.rx.pre_dosid,
                conditions: this.rx.conditions
            })
                .then(function (response) {
                    this.rx = {
                        id: null,
                        pre_prd: null,
                        pre_prdid: null,
                        pre_name: '',
                        pre_srname: '',
                        pre_dosage: '',
                        pre_dosid: '',
                        conditions: []

                    };
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Prescription was created!'
                    });
                    this.listRx();
                }, (response) => {
                    this._handleErrors(response.data, '#rx-form')
                })
        },
        asyncFindRx(query) {
            if (query == '') {
                this.searchrxs = []
            } else {
                this.searchrxs = this.prescriptions
            }

        },
        asyncFindCondition(query) {
            this.searchconditions = query === '' ? [] : this.conditions
        },
        asyncFindConditionAdd(query) {
            if (query === '') {
                this.searchcons = []
            } else {
                this.searchcons = this.cons
            }
        },
        getCon() {
            this.$http.get('/api/conditions')
                .then(function (response) {
                    this.cons = response.data;
                }, (response) => {
                    log(response);
                })
        },
        addConFromRx(rx) {
            this.rx = rx;
            this.update = false;
            this.fromRx = true;
            this.con = {
                id: null,
                cnd_cdd: null,
                cnd_cddid: null,
                cnd_name: '',
                cnd_srname: '',
                prescriptions: [],
            }
        },
        addSrCon(tag) {
            this.rxForm=true;
            this.con.cnd_srname = tag;
            this.con.cnd_cdd = {
                cdd_name: tag,
                cdd_id: 0
            };
        },
        addSrPre(tag) {
            this.rx.pre_srname = tag;
            this.rx.pre_prd = {
                prd_name: tag,
                prd_id: 0
            };
        },
        customLabel(data) {
            return data.condition_data?data.condition_data.cdd_name:data.cnd_srname
        },
        updateRx() {
            //null safe injection
            if (this.rx.pre_prd == null) {
                this.rx.pre_prd = {prd_id: null};
            }

            this.$http.put(this.route, {
                pre_id: this.rx.id,
                pre_prdid: this.rx.pre_prd.prd_id,
                pre_name: this.rx.pre_name,
                pre_srname: this.rx.pre_srname,
                pre_dosage: this.rx.pre_dosage,
                pre_dosid: this.rx.pre_dosid,
                conditions: this.rx.conditions
            })
                .then(function (response) {
                    this.listRx();
                    if(response.bodyText=="1"){
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: 'Prescription was updated!'
                        });
                    }else{
                        this.$notify({
                            type: 'error',
                            title: 'Success',
                            text: response.bodyText
                        });
                    }
                }, (response) => {
                    this._handleErrors(response.data, '#rx-form')
                })
        },
        log(s) {
            console.log(s)
        },
        updateOldCondition(condition) {
            this.update = false
            this.con = condition;
        },
        saveCon() {
            this.$http.post(this.conroute, {
                cnd_id: this.con.id,
                cnd_cddid: this.con.cnd_cdd.cdd_id,
                cnd_name: this.con.cnd_name,
                cnd_srname: this.con.cnd_srname,
                prescriptions: this.con.prescriptions,
            })
                .then(function (response) {
                    this.getCon();
                    var con = this.con
                    if(con.cnd_srname!=''){
                        con.cnd_sr=1
                    }
                    this.rxForm = false;
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Condition was created!'
                    });
                    this.con = {
                        id: null,
                        cnd_cdd: null,
                        cnd_cddid: null,
                        cnd_name: '',
                        cnd_srname: '',
                        prescriptions: [],
                    }
                    con.cnd_id = response.body
                    con.condition_data = con.cnd_cdd;
                    this.rx.conditions = [con];
                }, (response) => {
                    this._handleErrors(response.data, '#con-form')
                })
        },
        listCon() {
            this.$http.get(this.route)
                .then(function (response) {
                    this.cons = response.data;
                    bus.$emit('listCon', this.cons);
                }, (response) => {
                    this._handleErrors(response.data, '#con-form')
                })
        },
        show(r) {
            this.update = true
            this.rx = {
                id: r.pre_id,
                pre_prd: {
                    prd_id: r.pre_sr ? 0 : r.pre_prdid,
                    prd_name: r.pre_sr ? r.pre_srname : r.prescription_data.prd_name,
                },
                pre_prdid: r.pre_prdid,
                pre_name: r.pre_name,
                pre_srname: r.pre_srname,
                pre_dosage: r.pre_dosage,
                pre_dosid: r.pre_dosid,
                conditions: r.conditions

            };
        },
        deleteRxById(rx) {
            if (!confirm('Do you really want to delete this prescription?'))
                return

            this.$http.delete(this.route + '/' + rx.pre_id)
                .then(function (response) {
                    this.listRx();
                    if(response.bodyText=="1"){
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: 'Prescription was deleted!'
                        });
                    }else{
                        this.$notify({
                            type: 'error',
                            title: 'Success',
                            text: response.bodyText
                        });
                    }
                    this.showModal = false;
                }, (response) => {
                    this._handleErrors(response.data, '#rx-form')
                })
        },
        _handleErrors: function (items, selector) {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()
            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        }
    }

}
</script>
